/* ============================= */
/* VERSION V1.1 - FOOTER FINAL */
/* ============================= */

import React, { useEffect, useState } from "react";
import "../styles/Footer.css";
import logo from "../assets/logo/logo-taxi-de-la-douce.svg";

const Footer = () => {
  const year = new Date().getFullYear();

  // compteur simple (localStorage)
  const [visits, setVisits] = useState(null);

  useEffect(() => {
    try {
      const key = "taxideladouce_visits";
      const current = Number(localStorage.getItem(key) || 0) + 1;
      localStorage.setItem(key, String(current));
      setVisits(current);
    } catch {
      setVisits(null);
    }
  }, []);

  return (
    <footer className="footer-premium" role="contentinfo">
      <div className="footer-container">
        <div className="footer-grid">
          {/* COLONNE MARQUE */}
          <div className="footer-col">
            <img
              src={logo}
              alt="Logo Taxi de la Douce"
              className="footer-logo"
              width="70"
              height="70"
              loading="lazy"
              decoding="async"
            />

            <h5 className="footer-title">Taxi de la Douce</h5>

            <p className="footer-subtitle">
              Taxi Belfort • Transferts gare de Belfort • Aéroport Bâle-Mulhouse •
              Longue distance
            </p>
          </div>

          {/* CONTACT */}
          <div className="footer-col">
            <h6 className="footer-heading">Contact</h6>

            <p className="footer-line">
              📞{" "}
              <a href="tel:+33749424919" className="footer-link">
                +33 7 49 42 49 19
              </a>
            </p>

            <p className="footer-line">
              📧{" "}
              <a href="mailto:taxibuc90@gmail.com" className="footer-link">
                taxibuc90@gmail.com
              </a>
            </p>

            <p className="footer-line">
              💬{" "}
              <a
                href="https://wa.me/33749424919"
                className="footer-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                WhatsApp
              </a>
            </p>
          </div>
        </div>

{/* Réseaux sociaux */}
<div className="footer-social">
  <a
    href="https://www.facebook.com/letransportdeladouce/"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Facebook Taxi de la Douce"
  >
    <i className="bi bi-facebook"></i>
  </a>

  <a
    href="https://www.instagram.com/chauffeurvtc90/"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Instagram Taxi de la Douce"
  >
    <i className="bi bi-instagram"></i>
  </a>

  <a
    href="https://snapchat.com/add/taxideladouce"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Snapchat Taxi de la Douce"
  >
    <i className="bi bi-snapchat"></i>
  </a>
</div>
        {/* BAS DE PAGE */}
        <div className="footer-bottom">
          <p>
            © {year} Taxi de la Douce — Tous droits réservés.
          </p>

          <p className="footer-dev">
            Site développé par Taxi de la Douce • Version 1.1
          </p>

          {visits !== null && (
            <p className="footer-visits">
              Visites du site : {visits}
            </p>
          )}
        </div>

      </div>
      
    </footer>
  );
};

export default Footer;
